import styled from "styled-components";
import React from "react";
import { StyledOptionalText } from "./prompt_with_secondary_text";
import { ParagraphMedium } from "baseui/typography";

const QuestionLabel = styled("div")`
  // Respect any line breaks in the label
  white-space: pre-wrap;
  max-width: 700px;
`;

const StyledSecondaryText = styled(ParagraphMedium)`
  color: ${({ theme }) => theme.colors.contentTertiary};
  margin-top: ${({ theme }) => theme.sizing.scale100};
  margin-bottom: 0;
  max-width: 700px;
`;

export const getFormControlLabel = (
  supplementalQuestionPrompt: string | undefined,
  label: string | undefined,
  optional: boolean,
  secondaryText: string | undefined,
  dataTest: string | undefined,
) => {
  // Display secondaryText under the main question label when supplementalQuestionPrompt is not present
  const styledSecondaryLabel = !supplementalQuestionPrompt && secondaryText && (
    <StyledSecondaryText data-test={`${dataTest}-secondary-text`}>
      {secondaryText}
    </StyledSecondaryText>
  );

  // We only want to show the optional text in the label if there is no supplemental question prompt and if the question is optional.
  // If there IS a supplemental question prompt AND it's optional, the optional text will be shown in the supplemental question prompt component instead of the traditional label prop.
  return !supplementalQuestionPrompt && optional ? (
    <>
      <QuestionLabel data-test={`${dataTest}-label`}>
        {label} <StyledOptionalText>(Optional)</StyledOptionalText>
      </QuestionLabel>
      {styledSecondaryLabel}
    </>
  ) : label ? (
    <>
      <QuestionLabel data-test={`${dataTest}-label`}>{label}</QuestionLabel>
      {styledSecondaryLabel}
    </>
  ) : null;
};
